import ChatExplainer from 'components/chats/ChatExplainer';
import PageTopBar from 'components/navigation/PageTopBar';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { colors } from 'design';

const useStyles = createUseStyles({
  pageContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    position: 'relative',
  },
  container: {
    padding: '8px 8px 0px',
    backgroundColor: colors.surface.page,
    height: '100%',
    overflowY: 'scroll',
  },
  htmlContainer: {
    width: '100',
  },
});

export default function MessagingHowto() {
  // Hooks
  const styles = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [queryStringParams, setQueryStringParams] = useSearchParams();
  const scrollableElement = useRef<HTMLDivElement>(null);

  function onBackButtonClick() {
    navigate(-1);
  }

  return (
    <div className={styles.pageContainer}>
      <PageTopBar title={t('chats.explainer.title')} backButton onBackButtonClicked={() => onBackButtonClick()} />
      <div className={styles.container} ref={scrollableElement}>
        <ChatExplainer scrollableElement={scrollableElement} disableNewConversationButton />
      </div>
    </div>
  );
}
